// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitHotelNameLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/SearchUnitHotelNameLayout/SearchUnitHotelNameLayout.scss
 ** module id = 962
 ** module chunks = 1
 **/